import React from 'react';
const FANS = [{
  rank: 1,
  name: 'Emmy.Sweety',
  title: 'Webmaster & #1 Fan FOREVER',
  status: '🌟 ONLINE NOW 🌟',
  color: '#FFD700'
}, {
  rank: 2,
  name: 'cityandsin1993',
  title: 'Honorary Best Friend & Genius',
  status: '💖 ONLINE NOW 💖',
  color: '#C0C0C0'
}];
export function TopFans() {
  return <section className="w-full max-w-3xl mx-auto mb-12" data-id="element-187">
      <div className="bg-[#ffe0f0] retro-border p-5 retro-shadow" data-id="element-188">
        <h2 className="text-2xl md:text-3xl text-center text-[#cc0066] mb-4" style={{
        textShadow: '1px 1px 0px #fff'
      }} data-id="element-189">
          ~*~ TOP FANS LEADERBOARD ~*~
        </h2>
        <p className="text-center text-sm text-[#8b008b] mb-4" data-id="element-190">
          ⭐ Only the MOST dedicated fans make this list!!! ⭐
        </p>

        <div className="space-y-3" data-id="element-191">
          {FANS.map(fan => <div key={fan.rank} className="bg-white border-3 p-4 flex items-center gap-4" style={{
          borderStyle: 'ridge',
          borderColor: fan.color,
          borderWidth: '4px',
          boxShadow: `3px 3px 0px ${fan.color}`
        }} data-id="element-192">
              <div className="text-3xl font-bold flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-full" style={{
            backgroundColor: fan.color,
            color: fan.rank === 1 ? '#8b0000' : '#333',
            border: '3px solid #ff1493'
          }} data-id="element-193">
                #{fan.rank}
              </div>
              <div className="flex-1" data-id="element-194">
                <div className="flex items-center gap-2 flex-wrap" data-id="element-195">
                  <span className="text-lg font-bold text-[#660044]" data-id="element-196">
                    {fan.name}
                  </span>
                  {fan.rank === 1 && <span className="text-xs bg-[#ff1493] text-white px-2 py-0.5 font-bold" data-id="element-197">
                      👑 WEBMASTER
                    </span>}
                  {fan.rank === 2 && <span className="text-xs bg-[#9370db] text-white px-2 py-0.5 font-bold" data-id="element-198">
                      🧠 GENIUS
                    </span>}
                </div>
                <p className="text-xs text-gray-600 italic" data-id="element-199">{fan.title}</p>
                <p className="text-xs font-bold mt-1 animate-blink" style={{
              color: fan.rank === 1 ? '#ff1493' : '#9370db'
            }} data-id="element-200">
                  {fan.status}
                </p>
              </div>
              <div className="text-2xl flex-shrink-0" data-id="element-201">
                {fan.rank === 1 ? '👑' : '🌟'}
              </div>
            </div>)}
        </div>

        <div className="text-center mt-4 text-xs text-[#8b008b]" data-id="element-202">
          Want to be on this list??? Email me at cedrineluvr4eva@hotmail.com and
          tell me why you deserve it!!!
        </div>
      </div>
    </section>;
}